import { History } from "../components/History";
import { Team } from "../components/Team";
import { RegionLive } from "../components/RegionLive";
import { CtaBand } from "../components/CtaBand";
import { useTitle } from "../components/Reveal";

export default function UeberUns() {
  useTitle("Über uns – Manfred Berglar · Malermeister seit 1925");
  return (
    <div className="bg-white text-ink overflow-x-clip">
      <h1 className="sr-only">Über uns – Manfred Berglar, Malermeister seit 1925</h1>
      <div className="pt-[76px] md:pt-[88px]">
        <History />
        <Team />
        <RegionLive />
        <CtaBand
          title="Lernen wir uns persönlich kennen."
          text="Ein Anruf genügt – oder schreiben Sie uns direkt über das Kontaktformular."
        />
      </div>
    </div>
  );
}
